<template>
    <div class="position-relative">

        <template v-if="images.length">
            <VueSlickCarousel v-bind="settings" @afterChange="change">
                <GalleryCard
                    v-for="item in images"
                    :key="item.image.id"
                    :image-url="item.image.url"/>
            </VueSlickCarousel>
        </template>

        <div class="gallery-card-text c-white">{{ imageCaption }}</div>

    </div>
</template>

<script>

    import axios from 'axios';
    import VueSlickCarousel from 'vue-slick-carousel';
    import 'vue-slick-carousel/dist/vue-slick-carousel.css';
    import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';

    import GalleryCard from '@/components/carousels/cards/Gallery';

    export default {
        name: 'GalleryCarousel',
        components: {VueSlickCarousel,GalleryCard},

        props: {
            postId: {
                type: String,
                required: true
            }
        },

        data() {
          return {
              data: null,
              index: 0,
              settings: {
                  "autoplay": true,
                  "centerMode": true,
                  "focusOnSelect": true,
                  "infinite": true,
                  "slidesToShow": 1,
                  "speed": 500,
                  "arrows": true,
                  "responsive": [
                      {
                          "breakpoint": 475,
                          "settings": {
                              "infinite": true,
                              "centerPadding": "6px",
                          }
                      },
                  ],
              }
          }
        },

        computed: {

            images() {
              return this.data
                ? this.data.images
                : [];
            },

            captions() {
                let captions = [];
                for (let item of this.images) {
                    let caption = '';
                    if (item.caption) {
                        caption = item.caption;
                    } else {
                        if (item.image.hasOwnProperty('caption')) caption = item.image.caption;
                    }
                    captions.push(caption);
                }
                return captions;
            },

            imageCaption() {
                return this.captions.length
                    ? this.captions[this.index]
                    : '';
            }
        },

        mounted() {
            this.loadData();
        },

        methods: {
            loadData() {
                this.getGalleryImages();
            },

            getGalleryImages() {
                const $this = this;
                return new Promise((resolve, reject) => {
                    axios
                        .get(`/api/post/${this.postId}/page-content/gallery`)
                        .then(({ data }) => {
                            $this.data = data;
                            return resolve();
                        })
                        .catch((error) => {
                            return reject();
                        });
                });
            },

            change(index) {
                this.index = index;
            }
        }
    }
</script>
